document.addEventListener('DOMContentLoaded', async () => {
  const grid = document.getElementById('axis80-thread-grid');
  const spinner = document.getElementById('axis80-loading-spinner');
  if (!grid) {
    console.error('[Axis80] Could not find #axis80-thread-grid container.');
    return;
  }

  let page = 1;
  const products = [];
  
    function shouldSortByColorNumber() {
        const params = new URLSearchParams(window.location.search);
        // console.log('[Axis80] params', params);
        return (params.get('sort_by') || '').toLowerCase() === 'title-ascending';
    }

    function compareColorNumber(a, b) {
      const normalize = (val) => {
        const str = String(val).trim();
        // If the string is all digits, pad to 4 places
        return /^\d+$/.test(str) ? str.padStart(4, '0') : str;
      };

      const aNorm = normalize(a.color_number);
      const bNorm = normalize(b.color_number);

      // console.log('[Axis80] Comparing', aNorm, 'to', bNorm);

      return aNorm.localeCompare(bNorm);
    }

  async function fetchPage() {
    const url = `${window.location.pathname}?view=axis80-json&page=${page}`;
    // console.log(`[Axis80] Fetching page ${page}: ${url}`);

    try {
      const response = await fetch(url);
      const text = await response.text();

      let data;
      try {
        data = JSON.parse(text);
      } catch (err) {
        console.error(`[Axis80] Failed to parse JSON on page ${page}`, err);
        console.log(text.slice(0, 500));
        return null;
      }

      if (!data.products || !Array.isArray(data.products)) {
        console.warn(`[Axis80] No products array found on page ${page}.`, data);
        return null;
      }

      products.push(...data.products);
      // console.log(`[Axis80] Page ${page}: Loaded ${data.products.length} products`);

      if (page < data.pagination.total_pages) {
        page++;
        return fetchPage();
      } else {
        // console.log(`[Axis80] Loaded all ${products.length} products`);
        return products;
      }
    } catch (err) {
      console.error(`[Axis80] Fetch failed on page ${page}`, err);
      return null;
    }
  }

  function renderProducts(products) {
    spinner.style.display = 'none';
    if (!products.length) {
      grid.innerHTML = '<li>No products found.</li>';
      return;
    }

    const fragment = document.createDocumentFragment();

    products.forEach(p => {
      const container = document.createElement('div');
      container.className = 'axis80-color-option-container';

      const colorName = p.color_name || p.title || '';
      const colorCode = p.color_number ? `Color ${p.color_number}` : '';
      const imageUrl = p.image || '';
      const variantId = p.variant_id || '';
      const price = p.price || '';

      const quickBuySettings = JSON.stringify({
        cart_redirection: null,
        money_format: '${{amount}}'
      }).replace(/"/g, '&quot;');

container.innerHTML = `
      <article class="axis80-color-option" data-product-item="" tabindex="1" style="--open-height: 319.34375px;">
        <div class="productitem axis80-productitem-thread" data-product-item-content="">
          <div class="axis80-color-name">${colorName}</div>
          <div class="axis80-color-option-swatch" style="background-image: url('${imageUrl}')"></div>
          <div class="axis80-color-option-code">${colorCode}</div>
          <div class="axis80-color-option-price"><span class="money">· ${price}</span></div>
          <div class="axis80-color-option-addtocart" data-product-actions="">
            <div class="axis80-color-option-selectqty">
              <label>Qty</label>
              <input type="number" value="1" min="1" max="999"><br>
            </div>
            <button class="axis80-add-to-cart productitem--action-trigger productitem--action-atc button-primary mdc-ripple-surface mdc-ripple-upgraded"
              type="button"
              aria-label="Add to cart"
              data-quick-buy=""
              data-variant-id="${variantId}">
              <span class="atc-button--text">Add to cart</span>
              <span class="atc-button--icon">
                <svg aria-hidden="true" focusable="false" role="presentation" width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
                  <g fill-rule="nonzero" fill="currentColor">
                    <path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-3.852a9.148 9.148 0 1 0 0-18.296 9.148 9.148 0 0 0 0 18.296z" opacity=".29"></path>
                    <path d="M13 26c7.18 0 13-5.82 13-13a1.926 1.926 0 0 0-3.852 0A9.148 9.148 0 0 1 13 22.148 1.926 1.926 0 0 0 13 26z"></path>
                  </g>
                </svg>
              </span>
            </button>
          </div>
        </div>
        <script type="application/json" data-quick-buy-settings="">
          ${quickBuySettings}
        </script>
      </article>
    `;

      fragment.appendChild(container);
    });

    grid.appendChild(fragment);
    // console.log(`[Axis80] Rendered ${products.length} products`);
  }

    const result = await fetchPage();

    console.log('will render');

    if (shouldSortByColorNumber()) {
      result.sort(compareColorNumber);
    }

    if (result) renderProducts(result);

  grid.addEventListener('click', async (event) => {
    event.preventDefault();

      const button = event.target.closest('.productitem--action-atc');
      if (!button) {
        console.error('[Axis80] Couldn\'t find closest button');
        return;
      }

      const container = button.closest('.axis80-color-option-container');
      if (!container) {
        console.error('[Axis80] Couldn\'t find closest container');
        return;
      }

      const input = container.querySelector('input[type="number"]');
      const quantity = parseInt(input?.value || '1', 10);
      const variantId = button.dataset.variantId;

      // Find the static proxy ATC button
      const proxyContainer = document.getElementById('axis80-color-option-container-static');
      if (!proxyContainer) return console.error('[Axis80] Static proxy container not found');

      const proxyQtyInput = proxyContainer.querySelector('.axis80-color-option-selectqty input');
      const proxyATCButton = proxyContainer.querySelector('[data-quick-buy]');

      if (!proxyATCButton) return console.error('[Axis80] Static ATC button not found');

      // Update the static button's attributes
      proxyATCButton.setAttribute('data-variant-id', variantId);
      if (proxyQtyInput) {
        proxyQtyInput.value = quantity;
      }

      // Show the spinner on the clicked button
      button.disabled = true;
      button.classList.add("processing");

      setTimeout(() => {
        button.classList.remove('processing');
        button.disabled = false;
      }, 1000);

      console.log('[Axis80] Triggering click on proxy button', proxyATCButton);

      // Trigger a click on the static button
      proxyATCButton.click();      

  });

});
